/**
 * MEDICLOUD REST API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface CapabilityEligibleIntervalApiModel { 
    ageFrom: number;
    ageTo: number;
    eligibleMonthInterval: number;
}

